import {
  parseConsumeGuardianInviteResponse,
  parseGuardianLinkRequest,
  parseGuardianLinkRequestListResponse,
  parseResolvedGuardianInvite
} from "@madamuh/domain";
import type {
  ConsumeGuardianInviteRequestDto,
  ConsumeGuardianInviteResponseDto,
  CreateGuardianLinkRequestDto,
  GuardianLinkRequestDto,
  GuardianLinkRequestListResponseDto,
  ResolveGuardianInviteRequestDto,
  ResolvedGuardianInviteDto
} from "@madamuh/domain";
import { apiGet, apiPost } from "./client";

export async function resolveGuardianInvite(
  tenantSlug: string,
  request: ResolveGuardianInviteRequestDto
): Promise<ResolvedGuardianInviteDto> {
  const response = await apiPost<ResolveGuardianInviteRequestDto, unknown>(
    `/api/v1/app/tenants/${tenantSlug}/guardian-invites/resolve`,
    request
  );

  return parseResolvedGuardianInvite(response);
}

export async function consumeGuardianInvite(
  tenantSlug: string,
  request: ConsumeGuardianInviteRequestDto
): Promise<ConsumeGuardianInviteResponseDto> {
  const response = await apiPost<ConsumeGuardianInviteRequestDto, unknown>(
    `/api/v1/app/tenants/${tenantSlug}/guardian-links/consume-invite`,
    request
  );

  return parseConsumeGuardianInviteResponse(response);
}

export async function createGuardianLinkRequest(
  tenantSlug: string,
  request: CreateGuardianLinkRequestDto
): Promise<GuardianLinkRequestDto> {
  const response = await apiPost<CreateGuardianLinkRequestDto, unknown>(
    `/api/v1/app/tenants/${tenantSlug}/guardian-link-requests`,
    request
  );

  return parseGuardianLinkRequest(response);
}

export async function fetchAdminGuardianLinkRequests(
  tenantSlug: string
): Promise<GuardianLinkRequestListResponseDto> {
  const response = await apiGet<unknown>(`/api/v1/admin/tenants/${tenantSlug}/guardian-link-requests`);
  return parseGuardianLinkRequestListResponse(response);
}

export async function approveGuardianLinkRequest(
  tenantSlug: string,
  requestId: string
): Promise<GuardianLinkRequestDto> {
  const response = await apiPost<Record<string, never>, unknown>(
    `/api/v1/admin/tenants/${tenantSlug}/guardian-link-requests/${requestId}/approve`,
    {}
  );

  return parseGuardianLinkRequest(response);
}

export async function rejectGuardianLinkRequest(
  tenantSlug: string,
  requestId: string
): Promise<GuardianLinkRequestDto> {
  const response = await apiPost<Record<string, never>, unknown>(
    `/api/v1/admin/tenants/${tenantSlug}/guardian-link-requests/${requestId}/reject`,
    {}
  );

  return parseGuardianLinkRequest(response);
}
